import React, { forwardRef } from 'react';
import './Input.css';

/*
 * SelectInput — the mock's `.select`. Wraps a native <select> for reliability
 * (real keyboard nav, mobile pickers, form semantics) with the mock's CSS
 * chevron affordance.
 *   size    : 'md' (38px) | 'sm' (32px)
 *   invalid : red border
 *   options : optional [{ value, label, disabled }] convenience; otherwise pass
 *             <option> children directly.
 *   placeholder : optional leading disabled/empty option.
 */
const SelectInput = forwardRef(function SelectInput({
  size = 'md',
  invalid = false,
  options,
  placeholder,
  className = '',
  children,
  value,
  ...rest
}, ref) {
  const cls = [
    'select',
    size === 'sm' ? 'select--sm' : '',
    invalid ? 'select--invalid' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <select ref={ref} className={cls} value={value} {...rest}>
      {placeholder != null && <option value="" disabled>{placeholder}</option>}
      {options
        ? options.map((o) => (
            <option key={o.value} value={o.value} disabled={o.disabled}>{o.label}</option>
          ))
        : children}
    </select>
  );
});

export default SelectInput;
